import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

// component listen to route change and scroll document to top
class RouteListener extends React.Component {
  componentDidUpdate(oldProps) {
    if(oldProps.location.pathname !== this.props.location.pathname) {
      document.documentElement.scrollTop = 0;
    }
  }
  render() {
    return null;
  }
}

RouteListener.propTypes = {
  location: PropTypes.object.isRequired,
};

export default withRouter(RouteListener);


// WEBPACK FOOTER //
// ./src/partialComponents/RouteListener.jsx